<h1 mat-dialog-title class="text-center font-weight-bold">Détail trajet</h1>




<div mat-dialog-content class="mt-4">




    <div *ngIf="element.isConnected === true">


        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Emplacement :</h4>
            <div class="col-12 col-md-8">
                <h4>{{element?.station_name}}</h4>
            </div>
        </div>

        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Vehicule :</h4>
            <div class="col-12 col-md-8">
                <h4>{{element?.car_name}}</h4>
            </div>
        </div>

        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Départ :</h4>
            <div  class="col-12 col-md-8">
                <h4>{{element?.station?.street}}, {{element?.station?.zipcode}}
                    <mat-icon matTooltip="Navigation" class="spanLink" (click)="openNewTab()"
                    aria-hidden="false" aria-label="Adresse">navigation</mat-icon>
                </h4>
            </div>
        </div>



        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Date début :</h4>
            <div class="col-12 col-md-8">
                <h4>{{getDateFormat(element?.startdate)}}</h4>
            </div>
        </div>

        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Déstination :</h4>
            <div class="col-12 col-md-8 p-b-4">
                <h4 class="p-b-4">{{element?.destination}}
                    <mat-icon matTooltip="Copier" class="spanLink" (click)="copyMessage(element?.destination)"
                        aria-hidden="false" aria-label="Adresse">file_copy</mat-icon>
                </h4>
            </div>
        </div>



        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Nombre de places restantes :</h4>
            <div class="col-12 col-md-8">
                <h4>{{element?.nbplace}}</h4>
            </div>
        </div>

        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique"></h4>
            <div class="col-12 col-md-8">
                <h4>Vous pouvez appeler <span class="font-weight-bold">{{element?.created_by.firstname}} </span> <span class="font-weight-bold"> {{element?.created_by.lastname}}</span> pour covoiturer tout ou partie de son trajet, s entendre sur le partage des frais et connaître son heure de depart.

                    Le code général des impôts recommande un tarif de partage de trajet inférieur ou égal à 0,20 CT du km.</h4>
            </div>
        </div>



        <div class="row">
            <h4 class="col-12 col-md-4 font-weight-bold text-lg-right chimique">Numéro de téléphone :</h4>
            <div class="col-12 col-md-8">
                <h4>{{element?.created_by.phonenumber}}
                    <mat-icon matTooltip="Appeler" class="spanLink" (click)="callPersonne(element)"
                    aria-hidden="false" aria-label="Adresse">phone</mat-icon>
                </h4>
            </div>
        </div>




    </div>


    <div *ngIf="element.isConnected === false">

        <div class="row justify-content-center">

            <div class="col-12  align-self-center mt-2">
                <div class="row justify-content-center">
                    <button tabindex="-1" mat-flat-button color="primary" 
                    (click)="openConnexion()" class="autopartage-bouton full-width main-button">
                        {{ 'CONNEXION.BOUTONCNX' | translate }}</button>
                </div>
            </div>


            <div class="col-12 mt-4">
                <h3 class="clem-font autopartage text-center mb-0">Pas encore de compte ?</h3>
                <h3 class="clem-font autopartage text-center">Inscrivez-vous en tant que covoitureur</h3>
            </div>

            <div class="col-12  align-self-center mt-2">
                <div class="row justify-content-center">
                    <button tabindex="-1" mat-raised-button color="primary" 
                    (click)="openInscription()" class="autopartage-bouton full-width main-button">
                        {{ 'CONNEXION.BOUTONSUBSCRIBE' | translate }}</button>
                </div>
            </div>

        </div>


    </div>


</div>


<!-- spinner -->
<!-- <div *ngIf="IsWait" class="col-12  spinner">
        <div class="row justify-content-center mt-4">
            <mat-spinner class="mt-5" strokeWidth="15" [diameter]="100" color="primary">
            </mat-spinner>
        </div>
    </div> -->



<div mat-dialog-actions class="row justify-content-center mb-1 mt-5">



    <button *ngIf="isUpdate === false" mat-raised-button mat-dialog-close tabindex="-1"
        (click)="onNoClick()">Fermer</button>


</div>